import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { LoyaltyApi } from "../../../services";

export type UseLoyaltyListRewardFiltersParams = {
  enabled?: boolean;
};

export const useLoyaltyListRewardFilters = ({ enabled = true }: UseLoyaltyListRewardFiltersParams = {}) => {
  return useQuery([QUERY_KEYS.loyaltyRewardFilters], () => LoyaltyApi.init().getRewardFilters(), {
    enabled,
    refetchOnWindowFocus: false,
  });
};
